module.exports = __webpack_public_path__ + "static/media/lobby-banner.3ecb3740.png";